<template>
<div class="max-dialog">
  <el-dialog
    :title="`${row.main_number}子订单详情`"
    width="600px"
    :append-to-body="true"
    :visible.sync="showDialog"
    center
  >
    <el-table
      v-loading="loading"
      :data="tableData"
      style="width:100%">
      <el-table-column
        type="index"
        label="序号">
      </el-table-column>
      <el-table-column
        prop="sub_order"
        label="子单号">
      </el-table-column>
    </el-table>
  </el-dialog>
</div>
</template>

<script>
import { getTransportDetail } from '@/models/orderModel'
export default {
  props: ['row', 'dialog'],
  data () {
    return {
      showDialog: this.dialog,
      tableData: [],
      loading: false
    }
  },
  watch: {
    dialog: {
      handler: function (val) {
        this.showDialog = val
      },
      immediate: true
    },
    showDialog: {
      handler: function (val) {
        if (!val) {
          this.$emit('cancel')
        }
      }
    }

  },
  methods: {
    cancelHandler () {
      this.showDialog = false
      this.$emit('cancel')
    },
    confirmHandler () {
      this.$emit('confirm')
    }
  },
  created () {
    this.loading = true
    getTransportDetail({main_number: this.row.main_number})
      .then(res => {
        this.tableData = res.data
        this.loading = false
      })
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/order/TransportDetailDialog.vue